var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 5.89403C21.2642 6.21528 20.4734 6.43245 19.6433 6.53007C20.4905 6.03018 21.1411 5.23859 21.4475 4.29537C20.6547 4.75826 19.7765 5.09442 18.8419 5.27558C18.0934 4.49053 17.027 4 15.8469 4C13.5807 4 11.7435 5.80851 11.7435 8.03913C11.7435 8.35574 11.7798 8.66398 11.8497 8.95963C8.43955 8.7912 5.4161 7.18312 3.39231 4.73934C3.03911 5.33593 2.83679 6.02976 2.83679 6.77002C2.83679 8.17134 3.5612 9.40768 4.66218 10.132C3.98957 10.1111 3.35688 9.92936 2.80364 9.62682C2.80335 9.6437 2.80329 9.66058 2.80329 9.6776C2.80329 11.6347 4.21767 13.2672 6.09479 13.6383C5.75045 13.7305 5.38795 13.7799 5.01375 13.7799C4.74934 13.7799 4.49229 13.7546 4.24175 13.7075C4.76391 15.3122 6.27925 16.48 8.07478 16.5127C6.67047 17.596 4.90122 18.2417 2.97882 18.2417C2.64761 18.2417 2.32098 18.2226 2 18.1853C3.81589 19.3313 5.9727 20 8.28989 20C15.8373 20 19.9644 13.8452 19.9644 8.5075C19.9644 8.33239 19.9604 8.15819 19.9526 7.98498C20.7542 7.41547 21.4499 6.70405 22 5.89403Z",
    fill: "#38A1F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f518cbe3.svg";
export { ForwardRef as ReactComponent };